<template>
  <el-dialog
    :visible.sync="visible"
    title="确认付款"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      label-width="120px"
    >
      <el-form-item label="付款账户：" prop="accountId">
        <account v-model="dataForm.accountId"></account>
      </el-form-item>
      <el-form-item label="收款日期：" prop="accountId">
        <el-date-picker
            v-model="dataForm.operateTime"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            placeholder="选择收款日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="付款凭证：">
        <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
      </el-form-item>
      <el-table
        :data="dataForm.detailList"
        border
        style="width: 100%"
        :summary-method="getSummaries"
        show-summary

      >
        <el-table-column
          type="index"
          label="行号"
          width="60"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="发票号"
          prop="receiptCode"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column label="总应付" header-align="center" align="center">
          <template slot-scope="scope">
            {{ moneyFormat(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column label="剩余应付" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.limitAmount }}
          </template>
        </el-table-column>
        <el-table-column label="本次实付" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.realAmount'"
              :rules="detailRule.realAmount"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.realAmount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import MultipleImageUpload from "@/components/MultipleImageUpload";
import debounce from "lodash/debounce";
import { moneyValidator } from "@/utils/validate";
import BigNumber from "bignumber.js";
export default {
  components: { MultipleImageUpload },
  data() {
    return {
      visible: false,
      ids: [],
      dataForm: {},
      amount: "",
    };
  },
  computed: {
    dataRule() {
      return {
        operateTime: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        accountId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
      };
    },
    detailRule() {
      return {
        amount: [
          { required: true, message: "请填写实付金额", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
      };
    },
  },
  methods: {

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      sums[0] = "合计";
      let totalAmount = new BigNumber(0);
      let totalRealAmount = new BigNumber(0);
      data.forEach((row) => {
        if (row["amount"]) {
          const amount = new BigNumber(row["amount"]);
          totalAmount = totalAmount.plus(amount);
        }
        if (row["realAmount"]) {
          const realAmount = new BigNumber(row["realAmount"]);
          totalRealAmount = totalRealAmount.plus(realAmount);
        }
      });
      sums[columns.length - 2] = "总应付：" + this.moneyFormat(totalAmount) ;
      sums[columns.length - 1] = "总实付：" + totalRealAmount.toFixed(2);
      return sums;
    },
    init() {
      this.reset();
      if (this.$store.state.waitPayList) {
        this.$store.state.waitPayList.forEach((item) => {
          let totalAmount = new BigNumber(this.moneyFormat(item.amount));
          let realAmount = new BigNumber(item.realAmount);
          item.limitAmount = totalAmount.minus(realAmount);
          item.realAmount = item.limitAmount
        });
      }
      this.dataForm.detailList = this.$clone(this.$store.state.waitPayList);
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    reset() {
      this.imgArr = [];
      this.dataForm = {
        accountId: "",
        imgs: "",
        detailList: [],
      };
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = {
            accountId: this.dataForm.accountId,
            imgs: this.dataForm.imgs,
            operateTime:this.dataForm.operateTime,
            payList: [],
          };
          this.dataForm.detailList.forEach((item) => {
            postForm.payList.push({
              id: item.id,
              realAmount: item.realAmount,
            });
          });

          this.$http
            .post("/trade/payrecord/pay", postForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
